import React, { Component } from "react";

class Loader extends Component {
  render() {
    return (
      <div className="spinner-border text-secondary color--custom" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
}

export default Loader;